import { Outlet, NavLink } from "react-router-dom";
import { cn } from "../../lib/cn";

type NavItem = { to: string; label: string; icon: string };

const NAV_ITEMS: NavItem[] = [
  { to: "/tg/dashboard", label: "Dash", icon: "📊" },
  { to: "/tg/today", label: "Today", icon: "🏠" },
  { to: "/tg/calendar", label: "Calendar", icon: "📅" },
  { to: "/tg/waitlist", label: "Waitlist", icon: "⏳" },
  { to: "/tg/clients", label: "Clients", icon: "👥" },
  { to: "/tg/services", label: "Services", icon: "✂️" },
  { to: "/tg/staff", label: "Staff", icon: "🧑‍🔧" },
  { to: "/tg/settings", label: "Settings", icon: "⚙️" },
  { to: "/tg/integrations", label: "Links", icon: "🔌" },
];

export function TgLayout() {
  return (
    <div className="flex h-screen max-w-lg mx-auto flex-col bg-gray-50">
      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>
      <nav className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto overflow-x-auto border-t border-gray-200 bg-white/95 backdrop-blur">
        <div className="flex min-w-max">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  "flex w-[72px] flex-col items-center py-2 text-xs transition-colors",
                  isActive ? "font-semibold text-teal-600" : "text-gray-500"
                )
              }
            >
              <span className="text-xl">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
